<template>
    <router-view />
</template>
  
<script>
  export default {
    name: "MySite",
  };
</script>
  